import { RpcService } from 'rpc';

export interface IRCSRPCService extends RpcService {
	use_headless(): Promise<boolean>;
	load_path(params: { rest: string; hostname: string; urischeme: string }): Promise<any>;
}

export const svc: IRCSRPCService = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `${window.hcstatic.portal_url}/@@rcs.rpc`,

	services: {
		use_headless: {
			parameters: []
		},
		load_path: {
			parameters: [
				{
					name: 'rest',
					type: 'string',
					optional: false
				},
				{
					name: 'hostname',
					type: 'string',
					optional: false
				},
				{
					name: 'urischeme',
					type: 'string',
					optional: false
				}
			]
		}
	}
}) as IRCSRPCService;

export default svc;
